import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  pagination: {
    totalPages: 0,
    currentPage: 0,
    size: 10,
  },
  sorting: undefined,
  filters: {},
};

export const tableConfigSlice = createSlice({
  name: 'statutes',
  initialState,
  reducers: {
    setTablePagination(state, action) {
      state.pagination.totalPages = action.payload.totalPages;
    },
    setTableCurrentPage(state, action) {
      state.pagination.currentPage = action.payload;
    },
    setTableSize(state, action) {
      state.pagination.size = action.payload;
    },
    setTableFilters(state, action) {
      state.filters = action.payload;
    },
    setTableSorting(state, action) {
      state.sorting = action.payload;
    },
  },
});

export const getTotalPages = (rootState: RootState) =>
  rootState.tableConfig.pagination.totalPages;
export const getCurrentPage = (rootState: RootState) =>
  rootState.tableConfig.pagination.currentPage;
export const getSize = (rootState: RootState) => rootState.tableConfig.pagination.size;
export const getFilters = (rootState: RootState) => rootState.tableConfig.filters;
export const getTableSorting = (rootState: RootState) => rootState.tableConfig.sorting;

export const {
  setTablePagination,
  setTableCurrentPage,
  setTableSize,
  setTableFilters,
  setTableSorting,
} = tableConfigSlice.actions;
